// extracted by mini-css-extract-plugin
module.exports = {"loginRegistrationForm":"LoginRegistrationForm_loginRegistrationForm__eKVrT"};